/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Slots_SummaryInputs */

const en_slots_summary = /** @type {(inputs: Slots_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.shown} of ${i?.total}`)
};

const de_slots_summary = /** @type {(inputs: Slots_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.shown} von ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{shown} of {total}" |
*
* @param {Slots_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slots_summary = /** @type {((inputs: Slots_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slots_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slots_summary(inputs)
	return en_slots_summary(inputs)
});